// extracted by mini-css-extract-plugin
var _1 = "BAKS78yJPu";
export { _1 as "root" }
